import { cfJsonAnchorSchema } from "components/Anchor/schema";
import { object, record, string } from "superstruct";

export const headerLogoSchema = object({
  image: object({
    // the src of the image
    src: string(),
    alt: string(),
  }),
  ctaAnchor: cfJsonAnchorSchema,
});

export const translationsSchema = record(string(), string());
